import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

// Services

import { logOutUser } from '../../store/auth/auth.actions';

// Styles

import styles from './Header.module.scss';

// Images

import logo from './Images/img-brand-logo.png';
import icnHome from './Images/icn-home.png';
import icnLogOut from './Images/icn-logout.png';

export default function Header() {
    const login = useSelector((state) => state.auth.login);
    const user = useSelector((state) => state.auth.user);
    const logout = useSelector((state) => state.auth.logout);
    const dispatch = useDispatch();

    // Log out the user

    const handleUserLogOut = async () => {
        const data = {
            loginCliente: user?.loginCliente,
            ntv: user?.ntv,
        }
        dispatch(logOutUser(data));
    }

    const confirmUserLogOut = async () => {
        if (window.confirm("¿Desea cerrar la sesión?")) {
          handleUserLogOut();
        }
    }

    return (
        <div className={styles.header}>
            <div className='container'>
                <div className={styles.wrapper}>
                    <div>
                        <h1>
                            <img src={logo} alt="Bancaribe" className={styles.brand} />
                        </h1>

                        <Link to={'/'} className={styles.btnHome}>
                            <img src={icnHome} alt="Inicio" />
                            <span>Inicio</span>
                        </Link>
                    </div>

                    {login?.isLoggedIn &&
                    <div>
                        <p className={styles.date}><em>Última conexión <strong>{user?.date} | {user?.identifiacion}</strong></em></p>

                        <button type="button" className={styles.btnLogOut} disabled={logout?.isLoading} onClick={() => confirmUserLogOut()}>
                            {logout?.isLoading ? (
                                <FontAwesomeIcon className={styles.icnLogOutLoading} style={{fontSize: 24}} icon={faSpinner} spin />
                            ) : (
                                <img src={icnLogOut} alt="Cerrar Sesión" />
                            )}
                        </button>
                    </div>}
                </div>
            </div>
        </div>
    )
}
